export * from './authorization.service';
import { AuthorizationService } from './authorization.service';
export * from './business.service';
import { BusinessService } from './business.service';
export * from './metrics.service';
import { MetricsService } from './metrics.service';
export * from './newAccount.service';
import { NewAccountService } from './newAccount.service';
export * from './resource.service';
import { ResourceService } from './resource.service';
export * from './square.service';
import { SquareService } from './square.service';
export * from './stripe.service';
import { StripeService } from './stripe.service';
export * from './userResource.service';
import { UserResourceService } from './userResource.service';
export * from './viewAuthorizations.service';
import { ViewAuthorizationsService } from './viewAuthorizations.service';
export * from './weatherForecast.service';
import { WeatherForecastService } from './weatherForecast.service';
export const APIS = [AuthorizationService, BusinessService, MetricsService, NewAccountService, ResourceService, SquareService, StripeService, UserResourceService, ViewAuthorizationsService, WeatherForecastService];
